/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { StreemApiBatchCreateCompanyRequestToJSON, StreemApiBatchCreateCompanyResponseFromJSON, StreemApiChangeExternalUserIdRequestToJSON, StreemApiChangeExternalUserIdResponseFromJSON, StreemApiCreateCompanyApiKeyRequestToJSON, StreemApiCreateCompanyApiKeyResponseFromJSON, StreemApiCreateCompanyAssetRequestToJSON, StreemApiCreateCompanyAssetResponseFromJSON, StreemApiCreateCompanyCallSourceRequestToJSON, StreemApiCreateCompanyCallSourceResponseFromJSON, StreemApiCreateCompanyRequestToJSON, StreemApiCreateCompanyResponseFromJSON, StreemApiCreateCompanyRoomOutcomeConfigRequestToJSON, StreemApiCreateCompanyUserRequestToJSON, StreemApiCreateCompanyUserResponseFromJSON, StreemApiCreateGroupHoursOfOperationRequestToJSON, StreemApiCreateGroupHoursOfOperationResponseFromJSON, StreemApiCreateGroupRequestToJSON, StreemApiCreateGroupReservationRequestToJSON, StreemApiCreateGroupReservationResponseFromJSON, StreemApiCreateGroupResponseFromJSON, StreemApiCreateInvitationRequestToJSON, StreemApiCreateInvitationResponseFromJSON, StreemApiCreateNoteTemplateRequestToJSON, StreemApiCreateNoteTemplateResponseFromJSON, StreemApiCreatePiiRequestRequestToJSON, StreemApiCreatePiiRequestResponseFromJSON, StreemApiDeleteCompanySettingResponseFromJSON, StreemApiGetCompanyApiKeyResponseFromJSON, StreemApiGetCompanyCallLogResponseFromJSON, StreemApiGetCompanyCallSourceResponseFromJSON, StreemApiGetCompanyCallSourcesResponseFromJSON, StreemApiGetCompanyHoursOfOperationResponseFromJSON, StreemApiGetCompanyIdentityProviderResponseFromJSON, StreemApiGetCompanyLicenseResponseFromJSON, StreemApiGetCompanyResponseFromJSON, StreemApiGetCompanyRoomOutcomeConfigResponseFromJSON, StreemApiGetCompanyTagResponseFromJSON, StreemApiGetCurrentCompanyResponseFromJSON, StreemApiGetGroupHoursOfOperationResponseFromJSON, StreemApiGetGroupReservationResponseFromJSON, StreemApiGetGroupReservationWaitTimeResponseFromJSON, StreemApiGetGroupResponseFromJSON, StreemApiGetOrCreateUserRequestToJSON, StreemApiGetOrCreateUserResponseFromJSON, StreemApiGetPublicLoginConfigurationResponseFromJSON, StreemApiGetSettingDefinitionRequestToJSON, StreemApiGetSettingDefinitionResponseFromJSON, StreemApiGetUserByExternalUserIdResponseFromJSON, StreemApiListCompaniesResponseFromJSON, StreemApiListCompanyApiKeysResponseFromJSON, StreemApiListCompanyPublicSettingsResponseFromJSON, StreemApiListCompanySettingsResponseFromJSON, StreemApiListCompanyTagsResponseFromJSON, StreemApiListCompanyUsersResponseFromJSON, StreemApiListGroupAvailabilityRequestFromJSON, StreemApiListGroupUsersResponseFromJSON, StreemApiListGroupsResponseFromJSON, StreemApiListNoteTemplatesResponseFromJSON, StreemApiListUserGroupsResponseFromJSON, StreemApiSaveCompanyLicenseRequestToJSON, StreemApiSaveCompanyLicenseResponseFromJSON, StreemApiSaveCompanySettingRequestToJSON, StreemApiSaveCompanySettingResponseFromJSON, StreemApiSaveCompanyTagRequestToJSON, StreemApiSaveCompanyTagResponseFromJSON, StreemApiSearchCompaniesForUserEmailRequestToJSON, StreemApiSearchCompaniesForUserEmailResponseFromJSON, StreemApiTransferGroupReservationToRequeueRequestToJSON, StreemApiUpdateCompanyCallSourceRequestToJSON, StreemApiUpdateCompanyCallSourceResponseFromJSON, StreemApiUpdateCompanyIdentityProviderRequestToJSON, StreemApiUpdateCompanyIdentityProviderResponseFromJSON, StreemApiUpdateCompanyRequestToJSON, StreemApiUpdateCompanyResponseFromJSON, StreemApiUpdateGroupHoursOfOperationRequestToJSON, StreemApiUpdateGroupImageUrlRequestToJSON, StreemApiUpdateGroupImageUrlResponseFromJSON, StreemApiUpdateNoteTemplateRequestToJSON, StreemApiUpdateNoteTemplateResponseFromJSON, StreemApiUploadCompanyCallSourceLogoRequestToJSON, StreemApiUploadCompanyCallSourceLogoResponseFromJSON, StreemInternalApiSaveGroupAverageCallLengthRequestToJSON, StreemInternalApiSaveGroupAverageCallLengthResponseFromJSON, } from '../models';
/**
 *
 */
export class CompaniesApi extends runtime.BaseAPI {
    /**
     * Add a user to a group for a specific company.
     * Add user to group for company
     */
    async addGroupUserRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling addGroupUser.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling addGroupUser.');
        }
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling addGroupUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Add a user to a group for a specific company.
     * Add user to group for company
     */
    async addGroupUser(companyCodeOrSid, groupName, userId) {
        await this.addGroupUserRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, userId: userId });
    }
    /**
     * Create batch of companies. This endpoint fails forward even if some entries fail.See the single Create Company endpoint for details about required fields.
     * Batch create company
     */
    async batchCreateCompanyRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/~batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiBatchCreateCompanyRequestToJSON(requestParameters.streemApiBatchCreateCompanyRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiBatchCreateCompanyResponseFromJSON(jsonValue));
    }
    /**
     * Create batch of companies. This endpoint fails forward even if some entries fail.See the single Create Company endpoint for details about required fields.
     * Batch create company
     */
    async batchCreateCompany(streemApiBatchCreateCompanyRequest) {
        const response = await this.batchCreateCompanyRaw({ streemApiBatchCreateCompanyRequest: streemApiBatchCreateCompanyRequest });
        return await response.value();
    }
    /**
     * Cancel a group reservation for a specific company and group
     * Cancel group reservation
     */
    async cancelGroupReservationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling cancelGroupReservation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling cancelGroupReservation.');
        }
        if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
            throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling cancelGroupReservation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/cancel`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Cancel a group reservation for a specific company and group
     * Cancel group reservation
     */
    async cancelGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        await this.cancelGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
    }
    /**
     */
    async cancelQueuedGroupReservationsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling cancelQueuedGroupReservations.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling cancelQueuedGroupReservations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/~cancel-all`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async cancelQueuedGroupReservations(companyCodeOrSid, groupName) {
        await this.cancelQueuedGroupReservationsRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
    }
    /**
     * Change the `external_user_id`, which should be unique in the scope of the specified Company
     * Change User ID
     */
    async changeExternalUserIdRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling changeExternalUserId.');
        }
        if (requestParameters.externalUserId === null || requestParameters.externalUserId === undefined) {
            throw new runtime.RequiredError('externalUserId', 'Required parameter requestParameters.externalUserId was null or undefined when calling changeExternalUserId.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/users/{external_user_id}/~change-user-id`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"external_user_id"}}`, encodeURIComponent(String(requestParameters.externalUserId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiChangeExternalUserIdRequestToJSON(requestParameters.streemApiChangeExternalUserIdRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiChangeExternalUserIdResponseFromJSON(jsonValue));
    }
    /**
     * Change the `external_user_id`, which should be unique in the scope of the specified Company
     * Change User ID
     */
    async changeExternalUserId(companyCodeOrSid, externalUserId, streemApiChangeExternalUserIdRequest) {
        const response = await this.changeExternalUserIdRaw({ companyCodeOrSid: companyCodeOrSid, externalUserId: externalUserId, streemApiChangeExternalUserIdRequest: streemApiChangeExternalUserIdRequest });
        return await response.value();
    }
    /**
     * Confirm a group reservation for a specific company and group
     * Confirm group reservation
     */
    async confirmMatchedGroupReservationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling confirmMatchedGroupReservation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling confirmMatchedGroupReservation.');
        }
        if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
            throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling confirmMatchedGroupReservation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/confirm`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Confirm a group reservation for a specific company and group
     * Confirm group reservation
     */
    async confirmMatchedGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        await this.confirmMatchedGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
    }
    /**
     */
    async createCallSourceRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCallSource.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/call-source`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateCompanyCallSourceRequestToJSON(requestParameters.streemApiCreateCompanyCallSourceRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateCompanyCallSourceResponseFromJSON(jsonValue));
    }
    /**
     */
    async createCallSource(companyCodeOrSid, streemApiCreateCompanyCallSourceRequest) {
        const response = await this.createCallSourceRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateCompanyCallSourceRequest: streemApiCreateCompanyCallSourceRequest });
        return await response.value();
    }
    /**
     * Create a new Company.  Provide `parent_company_sid` to create a Sub-Company.  The number of Sub-Companies allowed is limited to 10 initially, but you can request to have this limit increased.  Sub-Companies cannot themselves have Sub-Companies.
     * Create Company
     */
    async createCompanyRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateCompanyRequestToJSON(requestParameters.streemApiCreateCompanyRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateCompanyResponseFromJSON(jsonValue));
    }
    /**
     * Create a new Company.  Provide `parent_company_sid` to create a Sub-Company.  The number of Sub-Companies allowed is limited to 10 initially, but you can request to have this limit increased.  Sub-Companies cannot themselves have Sub-Companies.
     * Create Company
     */
    async createCompany(streemApiCreateCompanyRequest) {
        const response = await this.createCompanyRaw({ streemApiCreateCompanyRequest: streemApiCreateCompanyRequest });
        return await response.value();
    }
    /**
     * Create a new API Key for the specified Company
     * Create API Key
     */
    async createCompanyApiKeyRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCompanyApiKey.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/api-keys`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateCompanyApiKeyRequestToJSON(requestParameters.streemApiCreateCompanyApiKeyRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateCompanyApiKeyResponseFromJSON(jsonValue));
    }
    /**
     * Create a new API Key for the specified Company
     * Create API Key
     */
    async createCompanyApiKey(companyCodeOrSid, streemApiCreateCompanyApiKeyRequest) {
        const response = await this.createCompanyApiKeyRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateCompanyApiKeyRequest: streemApiCreateCompanyApiKeyRequest });
        return await response.value();
    }
    /**
     * Upload a Company asset
     * Upload Asset
     */
    async createCompanyAssetRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCompanyAsset.');
        }
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling createCompanyAsset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/assets/{type}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateCompanyAssetRequestToJSON(requestParameters.streemApiCreateCompanyAssetRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateCompanyAssetResponseFromJSON(jsonValue));
    }
    /**
     * Upload a Company asset
     * Upload Asset
     */
    async createCompanyAsset(companyCodeOrSid, type, streemApiCreateCompanyAssetRequest) {
        const response = await this.createCompanyAssetRaw({ companyCodeOrSid: companyCodeOrSid, type: type, streemApiCreateCompanyAssetRequest: streemApiCreateCompanyAssetRequest });
        return await response.value();
    }
    /**
     * Create the configuration for post call outcomes dialog
     * Create a configuration for Room Outcomes
     */
    async createCompanyRoomOutcomeConfigRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCompanyRoomOutcomeConfig.');
        }
        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling createCompanyRoomOutcomeConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/room-outcome-config/{fileName}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters.fileName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateCompanyRoomOutcomeConfigRequestToJSON(requestParameters.streemApiCreateCompanyRoomOutcomeConfigRequest),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Create the configuration for post call outcomes dialog
     * Create a configuration for Room Outcomes
     */
    async createCompanyRoomOutcomeConfig(companyCodeOrSid, fileName, streemApiCreateCompanyRoomOutcomeConfigRequest) {
        await this.createCompanyRoomOutcomeConfigRaw({ companyCodeOrSid: companyCodeOrSid, fileName: fileName, streemApiCreateCompanyRoomOutcomeConfigRequest: streemApiCreateCompanyRoomOutcomeConfigRequest });
    }
    /**
     * Create a user for log-in for this Company
     * Create a user
     */
    async createCompanyUserRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCompanyUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/users`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateCompanyUserRequestToJSON(requestParameters.streemApiCreateCompanyUserRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateCompanyUserResponseFromJSON(jsonValue));
    }
    /**
     * Create a user for log-in for this Company
     * Create a user
     */
    async createCompanyUser(companyCodeOrSid, streemApiCreateCompanyUserRequest) {
        const response = await this.createCompanyUserRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateCompanyUserRequest: streemApiCreateCompanyUserRequest });
        return await response.value();
    }
    /**
     * Create a group for a specific company
     * Create group for company
     */
    async createGroupRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateGroupRequestToJSON(requestParameters.streemApiCreateGroupRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupResponseFromJSON(jsonValue));
    }
    /**
     * Create a group for a specific company
     * Create group for company
     */
    async createGroup(companyCodeOrSid, streemApiCreateGroupRequest) {
        const response = await this.createGroupRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateGroupRequest: streemApiCreateGroupRequest });
        return await response.value();
    }
    /**
     * Create hours of operation for a specific group in a company
     * Create hours of operation for group
     */
    async createGroupHoursRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroupHours.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling createGroupHours.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/hours`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateGroupHoursOfOperationRequestToJSON(requestParameters.streemApiCreateGroupHoursOfOperationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupHoursOfOperationResponseFromJSON(jsonValue));
    }
    /**
     * Create hours of operation for a specific group in a company
     * Create hours of operation for group
     */
    async createGroupHours(companyCodeOrSid, groupName, streemApiCreateGroupHoursOfOperationRequest) {
        const response = await this.createGroupHoursRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiCreateGroupHoursOfOperationRequest: streemApiCreateGroupHoursOfOperationRequest });
        return await response.value();
    }
    /**
     * Create a group reservation for a specific company and group
     * Create group reservation for company
     */
    async createGroupReservationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroupReservation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling createGroupReservation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateGroupReservationRequestToJSON(requestParameters.streemApiCreateGroupReservationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupReservationResponseFromJSON(jsonValue));
    }
    /**
     * Create a group reservation for a specific company and group
     * Create group reservation for company
     */
    async createGroupReservation(companyCodeOrSid, groupName, streemApiCreateGroupReservationRequest) {
        const response = await this.createGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiCreateGroupReservationRequest: streemApiCreateGroupReservationRequest });
        return await response.value();
    }
    /**
     * Create an Invitation from/to the provided Users
     * Create Invitation
     */
    async createInvitationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createInvitation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/invitations`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateInvitationRequestToJSON(requestParameters.streemApiCreateInvitationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateInvitationResponseFromJSON(jsonValue));
    }
    /**
     * Create an Invitation from/to the provided Users
     * Create Invitation
     */
    async createInvitation(companyCodeOrSid, streemApiCreateInvitationRequest) {
        const response = await this.createInvitationRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateInvitationRequest: streemApiCreateInvitationRequest });
        return await response.value();
    }
    /**
     * Create Note Template
     */
    async createNoteTemplateRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createNoteTemplate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/note-templates`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateNoteTemplateRequestToJSON(requestParameters.streemApiCreateNoteTemplateRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateNoteTemplateResponseFromJSON(jsonValue));
    }
    /**
     * Create Note Template
     */
    async createNoteTemplate(companyCodeOrSid, streemApiCreateNoteTemplateRequest) {
        const response = await this.createNoteTemplateRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateNoteTemplateRequest: streemApiCreateNoteTemplateRequest });
        return await response.value();
    }
    /**
     * Requests all Personally Identifiable Information (PII) associated with a user
     * Create user PII request
     */
    async createPiiRequestRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createPiiRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/pii-requests`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreatePiiRequestRequestToJSON(requestParameters.streemApiCreatePiiRequestRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreatePiiRequestResponseFromJSON(jsonValue));
    }
    /**
     * Requests all Personally Identifiable Information (PII) associated with a user
     * Create user PII request
     */
    async createPiiRequest(companyCodeOrSid, streemApiCreatePiiRequestRequest) {
        const response = await this.createPiiRequestRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreatePiiRequestRequest: streemApiCreatePiiRequestRequest });
        return await response.value();
    }
    /**
     */
    async deleteCallSourceRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCallSource.');
        }
        if (requestParameters.callSourceSid === null || requestParameters.callSourceSid === undefined) {
            throw new runtime.RequiredError('callSourceSid', 'Required parameter requestParameters.callSourceSid was null or undefined when calling deleteCallSource.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/call-source/{call_source_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"call_source_sid"}}`, encodeURIComponent(String(requestParameters.callSourceSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteCallSource(companyCodeOrSid, callSourceSid) {
        await this.deleteCallSourceRaw({ companyCodeOrSid: companyCodeOrSid, callSourceSid: callSourceSid });
    }
    /**
     * Deactivate Company/Users and optionally delete assets
     * Deactivate Company and assets
     */
    async deleteCompanyAndAssetsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCompanyAndAssets.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Deactivate Company/Users and optionally delete assets
     * Deactivate Company and assets
     */
    async deleteCompanyAndAssets(companyCodeOrSid) {
        await this.deleteCompanyAndAssetsRaw({ companyCodeOrSid: companyCodeOrSid });
    }
    /**
     * Delete Company Room Outcome Configuration for a specific Company
     * Delete Company Room Outcome Configuration
     */
    async deleteCompanyRoomOutcomeConfigRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCompanyRoomOutcomeConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/room-outcome-config`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete Company Room Outcome Configuration for a specific Company
     * Delete Company Room Outcome Configuration
     */
    async deleteCompanyRoomOutcomeConfig(companyCodeOrSid) {
        await this.deleteCompanyRoomOutcomeConfigRaw({ companyCodeOrSid: companyCodeOrSid });
    }
    /**
     * Delete a Setting for the specified Company, resetting it back to the default
     * Delete Setting
     */
    async deleteCompanySettingRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCompanySetting.');
        }
        if (requestParameters.settingName === null || requestParameters.settingName === undefined) {
            throw new runtime.RequiredError('settingName', 'Required parameter requestParameters.settingName was null or undefined when calling deleteCompanySetting.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/settings/{setting_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"setting_name"}}`, encodeURIComponent(String(requestParameters.settingName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiDeleteCompanySettingResponseFromJSON(jsonValue));
    }
    /**
     * Delete a Setting for the specified Company, resetting it back to the default
     * Delete Setting
     */
    async deleteCompanySetting(companyCodeOrSid, settingName) {
        const response = await this.deleteCompanySettingRaw({ companyCodeOrSid: companyCodeOrSid, settingName: settingName });
        return await response.value();
    }
    /**
     * Deletes a specified tag for the specified Company
     * Delete Company Tag
     */
    async deleteCompanyTagRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCompanyTag.');
        }
        if (requestParameters.tagName === null || requestParameters.tagName === undefined) {
            throw new runtime.RequiredError('tagName', 'Required parameter requestParameters.tagName was null or undefined when calling deleteCompanyTag.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/tags/{tag_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"tag_name"}}`, encodeURIComponent(String(requestParameters.tagName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Deletes a specified tag for the specified Company
     * Delete Company Tag
     */
    async deleteCompanyTag(companyCodeOrSid, tagName) {
        await this.deleteCompanyTagRaw({ companyCodeOrSid: companyCodeOrSid, tagName: tagName });
    }
    /**
     * Delete a group from a company
     * Delete group from company
     */
    async deleteGroupRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroup.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a group from a company
     * Delete group from company
     */
    async deleteGroup(companyCodeOrSid, groupName) {
        await this.deleteGroupRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
    }
    /**
     * Delete hours of operation for a specific group in a company
     * Delete all hours of operation for group
     */
    async deleteGroupHoursOfOperationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroupHoursOfOperation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroupHoursOfOperation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/hours`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupHoursOfOperationResponseFromJSON(jsonValue));
    }
    /**
     * Delete hours of operation for a specific group in a company
     * Delete all hours of operation for group
     */
    async deleteGroupHoursOfOperation(companyCodeOrSid, groupName) {
        const response = await this.deleteGroupHoursOfOperationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        return await response.value();
    }
    /**
     * Remove a user from a group for a specific company.
     * Remove user from group for company
     */
    async deleteGroupUserRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroupUser.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroupUser.');
        }
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteGroupUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a user from a group for a specific company.
     * Remove user from group for company
     */
    async deleteGroupUser(companyCodeOrSid, groupName, userId) {
        await this.deleteGroupUserRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, userId: userId });
    }
    /**
     * Delete Note Template
     */
    async deleteNoteTemplateRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteNoteTemplate.');
        }
        if (requestParameters.noteTemplateSid === null || requestParameters.noteTemplateSid === undefined) {
            throw new runtime.RequiredError('noteTemplateSid', 'Required parameter requestParameters.noteTemplateSid was null or undefined when calling deleteNoteTemplate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/note-templates/{note_template_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"note_template_sid"}}`, encodeURIComponent(String(requestParameters.noteTemplateSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete Note Template
     */
    async deleteNoteTemplate(companyCodeOrSid, noteTemplateSid) {
        await this.deleteNoteTemplateRaw({ companyCodeOrSid: companyCodeOrSid, noteTemplateSid: noteTemplateSid });
    }
    /**
     */
    async getCallSourceRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCallSource.');
        }
        if (requestParameters.callSourceSid === null || requestParameters.callSourceSid === undefined) {
            throw new runtime.RequiredError('callSourceSid', 'Required parameter requestParameters.callSourceSid was null or undefined when calling getCallSource.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/call-source/{call_source_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"call_source_sid"}}`, encodeURIComponent(String(requestParameters.callSourceSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyCallSourceResponseFromJSON(jsonValue));
    }
    /**
     */
    async getCallSource(companyCodeOrSid, callSourceSid) {
        const response = await this.getCallSourceRaw({ companyCodeOrSid: companyCodeOrSid, callSourceSid: callSourceSid });
        return await response.value();
    }
    /**
     */
    async getCallSourcesRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCallSources.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/call-source`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyCallSourcesResponseFromJSON(jsonValue));
    }
    /**
     */
    async getCallSources(companyCodeOrSid) {
        const response = await this.getCallSourcesRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get info for a specific Company
     * Get Company
     */
    async getCompanyRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompany.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyResponseFromJSON(jsonValue));
    }
    /**
     * Get info for a specific Company
     * Get Company
     */
    async getCompany(companyCodeOrSid) {
        const response = await this.getCompanyRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get an API Key by `api_key_id` for the specified Company
     * Get API Key
     */
    async getCompanyApiKeyRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyApiKey.');
        }
        if (requestParameters.apiKeyId === null || requestParameters.apiKeyId === undefined) {
            throw new runtime.RequiredError('apiKeyId', 'Required parameter requestParameters.apiKeyId was null or undefined when calling getCompanyApiKey.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/api-keys/{api_key_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"api_key_id"}}`, encodeURIComponent(String(requestParameters.apiKeyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyApiKeyResponseFromJSON(jsonValue));
    }
    /**
     * Get an API Key by `api_key_id` for the specified Company
     * Get API Key
     */
    async getCompanyApiKey(companyCodeOrSid, apiKeyId) {
        const response = await this.getCompanyApiKeyRaw({ companyCodeOrSid: companyCodeOrSid, apiKeyId: apiKeyId });
        return await response.value();
    }
    /**
     * Get the Call Log for the specified Company, which are all calls made by Users of the Company
     * Get Call Log
     */
    async getCompanyCallLogRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyCallLog.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }
        if (requestParameters.startTime !== undefined) {
            queryParameters['start_time'] = requestParameters.startTime.toISOString();
        }
        if (requestParameters.endTime !== undefined) {
            queryParameters['end_time'] = requestParameters.endTime.toISOString();
        }
        if (requestParameters.groupNames) {
            queryParameters['group_names'] = requestParameters.groupNames;
        }
        if (requestParameters.callStatuses) {
            queryParameters['call_statuses'] = requestParameters.callStatuses;
        }
        if (requestParameters.hasRoomNotes !== undefined) {
            queryParameters['has_room_notes'] = requestParameters.hasRoomNotes;
        }
        if (requestParameters.callSourceCodes) {
            queryParameters['call_source_codes'] = requestParameters.callSourceCodes;
        }
        if (requestParameters.filterTransferred !== undefined) {
            queryParameters['filter_transferred'] = requestParameters.filterTransferred;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/call-log`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyCallLogResponseFromJSON(jsonValue));
    }
    /**
     * Get the Call Log for the specified Company, which are all calls made by Users of the Company
     * Get Call Log
     */
    async getCompanyCallLog(companyCodeOrSid, pageSize, pageToken, filter, startTime, endTime, groupNames, callStatuses, hasRoomNotes, callSourceCodes, filterTransferred) {
        const response = await this.getCompanyCallLogRaw({ companyCodeOrSid: companyCodeOrSid, pageSize: pageSize, pageToken: pageToken, filter: filter, startTime: startTime, endTime: endTime, groupNames: groupNames, callStatuses: callStatuses, hasRoomNotes: hasRoomNotes, callSourceCodes: callSourceCodes, filterTransferred: filterTransferred });
        return await response.value();
    }
    /**
     */
    async getCompanyHoursOfOperationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyHoursOfOperation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/hours`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyHoursOfOperationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getCompanyHoursOfOperation(companyCodeOrSid) {
        const response = await this.getCompanyHoursOfOperationRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get the current Identity Provider for this Company
     * Get Identity Provider
     */
    async getCompanyIdentityProviderRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyIdentityProvider.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/identity-provider`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyIdentityProviderResponseFromJSON(jsonValue));
    }
    /**
     * Get the current Identity Provider for this Company
     * Get Identity Provider
     */
    async getCompanyIdentityProvider(companyCodeOrSid) {
        const response = await this.getCompanyIdentityProviderRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get the current License associated with this Company
     * Get Company License
     */
    async getCompanyLicenseRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyLicense.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/license`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyLicenseResponseFromJSON(jsonValue));
    }
    /**
     * Get the current License associated with this Company
     * Get Company License
     */
    async getCompanyLicense(companyCodeOrSid) {
        const response = await this.getCompanyLicenseRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get Company Room Outcome Configuration for a specific Company
     * Get Company Room Outcome Configuration
     */
    async getCompanyRoomOutcomeConfigRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyRoomOutcomeConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/room-outcome-config`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyRoomOutcomeConfigResponseFromJSON(jsonValue));
    }
    /**
     * Get Company Room Outcome Configuration for a specific Company
     * Get Company Room Outcome Configuration
     */
    async getCompanyRoomOutcomeConfig(companyCodeOrSid) {
        const response = await this.getCompanyRoomOutcomeConfigRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get a specified tag and its values for the specified Company
     * Get Company Tag
     */
    async getCompanyTagRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyTag.');
        }
        if (requestParameters.tagName === null || requestParameters.tagName === undefined) {
            throw new runtime.RequiredError('tagName', 'Required parameter requestParameters.tagName was null or undefined when calling getCompanyTag.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/tags/{tag_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"tag_name"}}`, encodeURIComponent(String(requestParameters.tagName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCompanyTagResponseFromJSON(jsonValue));
    }
    /**
     * Get a specified tag and its values for the specified Company
     * Get Company Tag
     */
    async getCompanyTag(companyCodeOrSid, tagName) {
        const response = await this.getCompanyTagRaw({ companyCodeOrSid: companyCodeOrSid, tagName: tagName });
        return await response.value();
    }
    /**
     * Returns the company associated with this account
     * Get Current Company
     */
    async getCurrentCompanyRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetCurrentCompanyResponseFromJSON(jsonValue));
    }
    /**
     * Returns the company associated with this account
     * Get Current Company
     */
    async getCurrentCompany() {
        const response = await this.getCurrentCompanyRaw();
        return await response.value();
    }
    /**
     * Get a group for a company by its name
     * Get group for company
     */
    async getGroupRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroup.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetGroupResponseFromJSON(jsonValue));
    }
    /**
     * Get a group for a company by its name
     * Get group for company
     */
    async getGroup(companyCodeOrSid, groupName) {
        const response = await this.getGroupRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        return await response.value();
    }
    /**
     * Get Hours of operation for a group
     * Get group for company
     */
    async getGroupHoursOfOperationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupHoursOfOperation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupHoursOfOperation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/hours`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetGroupHoursOfOperationResponseFromJSON(jsonValue));
    }
    /**
     * Get Hours of operation for a group
     * Get group for company
     */
    async getGroupHoursOfOperation(companyCodeOrSid, groupName) {
        const response = await this.getGroupHoursOfOperationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        return await response.value();
    }
    /**
     * Get a specified group reservation
     * Get Group Reservation
     */
    async getGroupReservationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupReservation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupReservation.');
        }
        if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
            throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling getGroupReservation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetGroupReservationResponseFromJSON(jsonValue));
    }
    /**
     * Get a specified group reservation
     * Get Group Reservation
     */
    async getGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        const response = await this.getGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
        return await response.value();
    }
    /**
     * Get group reservation wait time for a specific group
     * Get group reservation wait time
     */
    async getGroupReservationWaitTimeRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupReservationWaitTime.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupReservationWaitTime.');
        }
        if (requestParameters.priority === null || requestParameters.priority === undefined) {
            throw new runtime.RequiredError('priority', 'Required parameter requestParameters.priority was null or undefined when calling getGroupReservationWaitTime.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{priority}/wait_time`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"priority"}}`, encodeURIComponent(String(requestParameters.priority))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetGroupReservationWaitTimeResponseFromJSON(jsonValue));
    }
    /**
     * Get group reservation wait time for a specific group
     * Get group reservation wait time
     */
    async getGroupReservationWaitTime(companyCodeOrSid, groupName, priority) {
        const response = await this.getGroupReservationWaitTimeRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, priority: priority });
        return await response.value();
    }
    /**
     * List Note Templates
     */
    async getNoteTemplatesRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getNoteTemplates.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/note-templates`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListNoteTemplatesResponseFromJSON(jsonValue));
    }
    /**
     * List Note Templates
     */
    async getNoteTemplates(companyCodeOrSid) {
        const response = await this.getNoteTemplatesRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get or create a User for this Company with the provided `external_user_id`, returning their internal `user_sid`
     * Get/Create User
     */
    async getOrCreateUserRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getOrCreateUser.');
        }
        if (requestParameters.externalUserId === null || requestParameters.externalUserId === undefined) {
            throw new runtime.RequiredError('externalUserId', 'Required parameter requestParameters.externalUserId was null or undefined when calling getOrCreateUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/users/{external_user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"external_user_id"}}`, encodeURIComponent(String(requestParameters.externalUserId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiGetOrCreateUserRequestToJSON(requestParameters.streemApiGetOrCreateUserRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetOrCreateUserResponseFromJSON(jsonValue));
    }
    /**
     * Get or create a User for this Company with the provided `external_user_id`, returning their internal `user_sid`
     * Get/Create User
     */
    async getOrCreateUser(companyCodeOrSid, externalUserId, streemApiGetOrCreateUserRequest) {
        const response = await this.getOrCreateUserRaw({ companyCodeOrSid: companyCodeOrSid, externalUserId: externalUserId, streemApiGetOrCreateUserRequest: streemApiGetOrCreateUserRequest });
        return await response.value();
    }
    /**
     * Get the public login configuration, determining how to login to this company
     * Get Public Login Config
     */
    async getPublicLoginConfigurationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getPublicLoginConfiguration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/public-login-configuration`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetPublicLoginConfigurationResponseFromJSON(jsonValue));
    }
    /**
     * Get the public login configuration, determining how to login to this company
     * Get Public Login Config
     */
    async getPublicLoginConfiguration(companyCodeOrSid) {
        const response = await this.getPublicLoginConfigurationRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get any setting name\'s definition
     * Get Setting Definition
     */
    async getSettingDefinitionRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getSettingDefinition.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/~default-setting`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiGetSettingDefinitionRequestToJSON(requestParameters.streemApiGetSettingDefinitionRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetSettingDefinitionResponseFromJSON(jsonValue));
    }
    /**
     * Get any setting name\'s definition
     * Get Setting Definition
     */
    async getSettingDefinition(companyCodeOrSid, streemApiGetSettingDefinitionRequest) {
        const response = await this.getSettingDefinitionRaw({ companyCodeOrSid: companyCodeOrSid, streemApiGetSettingDefinitionRequest: streemApiGetSettingDefinitionRequest });
        return await response.value();
    }
    /**
     * Get User by `external_user_id`, which should be unique in the scope of the specified Company
     * Get User By External User Id
     */
    async getUserByExternalUserIdRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getUserByExternalUserId.');
        }
        if (requestParameters.externalUserId === null || requestParameters.externalUserId === undefined) {
            throw new runtime.RequiredError('externalUserId', 'Required parameter requestParameters.externalUserId was null or undefined when calling getUserByExternalUserId.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/users/{external_user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"external_user_id"}}`, encodeURIComponent(String(requestParameters.externalUserId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetUserByExternalUserIdResponseFromJSON(jsonValue));
    }
    /**
     * Get User by `external_user_id`, which should be unique in the scope of the specified Company
     * Get User By External User Id
     */
    async getUserByExternalUserId(companyCodeOrSid, externalUserId) {
        const response = await this.getUserByExternalUserIdRaw({ companyCodeOrSid: companyCodeOrSid, externalUserId: externalUserId });
        return await response.value();
    }
    /**
     * List companies or sub companies. Can filter based on parent company sid, active status, name, and/or company code.
     * List Companies
     */
    async listCompaniesRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }
        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }
        if (requestParameters.parentCompanySid !== undefined) {
            queryParameters['parent_company_sid'] = requestParameters.parentCompanySid;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListCompaniesResponseFromJSON(jsonValue));
    }
    /**
     * List companies or sub companies. Can filter based on parent company sid, active status, name, and/or company code.
     * List Companies
     */
    async listCompanies(pageSize, pageToken, sort, filter, active, parentCompanySid) {
        const response = await this.listCompaniesRaw({ pageSize: pageSize, pageToken: pageToken, sort: sort, filter: filter, active: active, parentCompanySid: parentCompanySid });
        return await response.value();
    }
    /**
     * List API keys for the specified Company
     * List API Keys
     */
    async listCompanyApiKeysRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listCompanyApiKeys.');
        }
        const queryParameters = {};
        if (requestParameters.includeExpired !== undefined) {
            queryParameters['include_expired'] = requestParameters.includeExpired;
        }
        if (requestParameters.expires !== undefined) {
            queryParameters['expires'] = requestParameters.expires;
        }
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/api-keys`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListCompanyApiKeysResponseFromJSON(jsonValue));
    }
    /**
     * List API keys for the specified Company
     * List API Keys
     */
    async listCompanyApiKeys(companyCodeOrSid, includeExpired, expires, pageSize, pageToken) {
        const response = await this.listCompanyApiKeysRaw({ companyCodeOrSid: companyCodeOrSid, includeExpired: includeExpired, expires: expires, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * Get those settings for the specified Company that are available without authentication
     * Get Public Settings
     */
    async listCompanyPublicSettingsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listCompanyPublicSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/public-settings`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListCompanyPublicSettingsResponseFromJSON(jsonValue));
    }
    /**
     * Get those settings for the specified Company that are available without authentication
     * Get Public Settings
     */
    async listCompanyPublicSettings(companyCodeOrSid) {
        const response = await this.listCompanyPublicSettingsRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get a list of Settings for the specified Company
     * Get Settings
     */
    async listCompanySettingsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listCompanySettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/settings`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListCompanySettingsResponseFromJSON(jsonValue));
    }
    /**
     * Get a list of Settings for the specified Company
     * Get Settings
     */
    async listCompanySettings(companyCodeOrSid) {
        const response = await this.listCompanySettingsRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * Get all tags and their values for the specified Company
     * Get Company Tags
     */
    async listCompanyTagsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listCompanyTags.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/tags`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListCompanyTagsResponseFromJSON(jsonValue));
    }
    /**
     * Get all tags and their values for the specified Company
     * Get Company Tags
     */
    async listCompanyTags(companyCodeOrSid, pageSize, pageToken) {
        const response = await this.listCompanyTagsRaw({ companyCodeOrSid: companyCodeOrSid, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List the users in the group that have a certain availability status
     * List Group Availability
     */
    async listGroupAvailabilityRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroupAvailability.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling listGroupAvailability.');
        }
        const queryParameters = {};
        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/availability`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListGroupAvailabilityRequestFromJSON(jsonValue));
    }
    /**
     * List the users in the group that have a certain availability status
     * List Group Availability
     */
    async listGroupAvailability(companyCodeOrSid, groupName, status, pageSize, pageToken) {
        const response = await this.listGroupAvailabilityRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, status: status, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List the users that belong to a group.
     * List users in group
     */
    async listGroupUsersRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroupUsers.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling listGroupUsers.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListGroupUsersResponseFromJSON(jsonValue));
    }
    /**
     * List the users that belong to a group.
     * List users in group
     */
    async listGroupUsers(companyCodeOrSid, groupName, pageSize, pageToken) {
        const response = await this.listGroupUsersRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List the groups associated with the company
     * List groups for company
     */
    async listGroupsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroups.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListGroupsResponseFromJSON(jsonValue));
    }
    /**
     * List the groups associated with the company
     * List groups for company
     */
    async listGroups(companyCodeOrSid) {
        const response = await this.listGroupsRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * List the groups that a user belongs to.
     * List user\'s groups
     */
    async listUserGroupsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listUserGroups.');
        }
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling listUserGroups.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListUserGroupsResponseFromJSON(jsonValue));
    }
    /**
     * List the groups that a user belongs to.
     * List user\'s groups
     */
    async listUserGroups(companyCodeOrSid, userId, pageSize, pageToken) {
        const response = await this.listUserGroupsRaw({ companyCodeOrSid: companyCodeOrSid, userId: userId, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * Get all Users associated with the specified Company
     * Get Users
     */
    async listUsersForCompanyRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listUsersForCompany.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }
        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }
        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.userTypes) {
            queryParameters['user_types'] = requestParameters.userTypes;
        }
        if (requestParameters.includeAvailabilityStatus !== undefined) {
            queryParameters['include_availability_status'] = requestParameters.includeAvailabilityStatus;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/users`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListCompanyUsersResponseFromJSON(jsonValue));
    }
    /**
     * Get all Users associated with the specified Company
     * Get Users
     */
    async listUsersForCompany(companyCodeOrSid, pageSize, pageToken, active, deleted, filter, sort, userTypes, includeAvailabilityStatus) {
        const response = await this.listUsersForCompanyRaw({ companyCodeOrSid: companyCodeOrSid, pageSize: pageSize, pageToken: pageToken, active: active, deleted: deleted, filter: filter, sort: sort, userTypes: userTypes, includeAvailabilityStatus: includeAvailabilityStatus });
        return await response.value();
    }
    /**
     * Revokes an API Key, which sets the `expires_at` date to now
     * Revoke API Key
     */
    async revokeCompanyApiKeyRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling revokeCompanyApiKey.');
        }
        if (requestParameters.apiKeyId === null || requestParameters.apiKeyId === undefined) {
            throw new runtime.RequiredError('apiKeyId', 'Required parameter requestParameters.apiKeyId was null or undefined when calling revokeCompanyApiKey.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/api-keys/{api_key_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"api_key_id"}}`, encodeURIComponent(String(requestParameters.apiKeyId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Revokes an API Key, which sets the `expires_at` date to now
     * Revoke API Key
     */
    async revokeCompanyApiKey(companyCodeOrSid, apiKeyId) {
        await this.revokeCompanyApiKeyRaw({ companyCodeOrSid: companyCodeOrSid, apiKeyId: apiKeyId });
    }
    /**
     * Saves or updates the current License assigned to this Company
     * Save Company License
     */
    async saveCompanyLicenseRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveCompanyLicense.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/license`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiSaveCompanyLicenseRequestToJSON(requestParameters.streemApiSaveCompanyLicenseRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiSaveCompanyLicenseResponseFromJSON(jsonValue));
    }
    /**
     * Saves or updates the current License assigned to this Company
     * Save Company License
     */
    async saveCompanyLicense(companyCodeOrSid, streemApiSaveCompanyLicenseRequest) {
        const response = await this.saveCompanyLicenseRaw({ companyCodeOrSid: companyCodeOrSid, streemApiSaveCompanyLicenseRequest: streemApiSaveCompanyLicenseRequest });
        return await response.value();
    }
    /**
     * Save a Setting for the specified Company
     * Save Setting
     */
    async saveCompanySettingRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveCompanySetting.');
        }
        if (requestParameters.settingName === null || requestParameters.settingName === undefined) {
            throw new runtime.RequiredError('settingName', 'Required parameter requestParameters.settingName was null or undefined when calling saveCompanySetting.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/settings/{setting_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"setting_name"}}`, encodeURIComponent(String(requestParameters.settingName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiSaveCompanySettingRequestToJSON(requestParameters.streemApiSaveCompanySettingRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiSaveCompanySettingResponseFromJSON(jsonValue));
    }
    /**
     * Save a Setting for the specified Company
     * Save Setting
     */
    async saveCompanySetting(companyCodeOrSid, settingName, streemApiSaveCompanySettingRequest) {
        const response = await this.saveCompanySettingRaw({ companyCodeOrSid: companyCodeOrSid, settingName: settingName, streemApiSaveCompanySettingRequest: streemApiSaveCompanySettingRequest });
        return await response.value();
    }
    /**
     * Creates/updates a specified tag for the specified Company
     * Save Company Tag
     */
    async saveCompanyTagRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveCompanyTag.');
        }
        if (requestParameters.tagName === null || requestParameters.tagName === undefined) {
            throw new runtime.RequiredError('tagName', 'Required parameter requestParameters.tagName was null or undefined when calling saveCompanyTag.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/tags/{tag_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"tag_name"}}`, encodeURIComponent(String(requestParameters.tagName))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiSaveCompanyTagRequestToJSON(requestParameters.streemApiSaveCompanyTagRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiSaveCompanyTagResponseFromJSON(jsonValue));
    }
    /**
     * Creates/updates a specified tag for the specified Company
     * Save Company Tag
     */
    async saveCompanyTag(companyCodeOrSid, tagName, streemApiSaveCompanyTagRequest) {
        const response = await this.saveCompanyTagRaw({ companyCodeOrSid: companyCodeOrSid, tagName: tagName, streemApiSaveCompanyTagRequest: streemApiSaveCompanyTagRequest });
        return await response.value();
    }
    /**
     */
    async saveGroupReservationWaitMetricRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveGroupReservationWaitMetric.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/reservation-metrics`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemInternalApiSaveGroupAverageCallLengthRequestToJSON(requestParameters.streemInternalApiSaveGroupAverageCallLengthRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemInternalApiSaveGroupAverageCallLengthResponseFromJSON(jsonValue));
    }
    /**
     */
    async saveGroupReservationWaitMetric(companyCodeOrSid, streemInternalApiSaveGroupAverageCallLengthRequest) {
        const response = await this.saveGroupReservationWaitMetricRaw({ companyCodeOrSid: companyCodeOrSid, streemInternalApiSaveGroupAverageCallLengthRequest: streemInternalApiSaveGroupAverageCallLengthRequest });
        return await response.value();
    }
    /**
     * List all Companies that have a member with the given email
     * List Companies For User Email
     */
    async searchCompaniesForUserEmailRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/user-email-search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiSearchCompaniesForUserEmailRequestToJSON(requestParameters.streemApiSearchCompaniesForUserEmailRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiSearchCompaniesForUserEmailResponseFromJSON(jsonValue));
    }
    /**
     * List all Companies that have a member with the given email
     * List Companies For User Email
     */
    async searchCompaniesForUserEmail(streemApiSearchCompaniesForUserEmailRequest) {
        const response = await this.searchCompaniesForUserEmailRaw({ streemApiSearchCompaniesForUserEmailRequest: streemApiSearchCompaniesForUserEmailRequest });
        return await response.value();
    }
    /**
     * Requeue a group reservation for a specific company and group
     * Requeue group reservation
     */
    async transferGroupReservationToRequeueRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling transferGroupReservationToRequeue.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling transferGroupReservationToRequeue.');
        }
        if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
            throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling transferGroupReservationToRequeue.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/~requeue`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiTransferGroupReservationToRequeueRequestToJSON(requestParameters.streemApiTransferGroupReservationToRequeueRequest),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Requeue a group reservation for a specific company and group
     * Requeue group reservation
     */
    async transferGroupReservationToRequeue(companyCodeOrSid, groupName, reservationSid, streemApiTransferGroupReservationToRequeueRequest) {
        await this.transferGroupReservationToRequeueRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid, streemApiTransferGroupReservationToRequeueRequest: streemApiTransferGroupReservationToRequeueRequest });
    }
    /**
     * Update certain properties of the specified Company
     * Update Company
     */
    async updateCompanyRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateCompany.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateCompanyRequestToJSON(requestParameters.streemApiUpdateCompanyRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUpdateCompanyResponseFromJSON(jsonValue));
    }
    /**
     * Update certain properties of the specified Company
     * Update Company
     */
    async updateCompany(companyCodeOrSid, streemApiUpdateCompanyRequest) {
        const response = await this.updateCompanyRaw({ companyCodeOrSid: companyCodeOrSid, streemApiUpdateCompanyRequest: streemApiUpdateCompanyRequest });
        return await response.value();
    }
    /**
     */
    async updateCompanyCallSourceRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateCompanyCallSource.');
        }
        if (requestParameters.callSourceSid === null || requestParameters.callSourceSid === undefined) {
            throw new runtime.RequiredError('callSourceSid', 'Required parameter requestParameters.callSourceSid was null or undefined when calling updateCompanyCallSource.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/call-source/{call_source_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"call_source_sid"}}`, encodeURIComponent(String(requestParameters.callSourceSid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateCompanyCallSourceRequestToJSON(requestParameters.streemApiUpdateCompanyCallSourceRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUpdateCompanyCallSourceResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateCompanyCallSource(companyCodeOrSid, callSourceSid, streemApiUpdateCompanyCallSourceRequest) {
        const response = await this.updateCompanyCallSourceRaw({ companyCodeOrSid: companyCodeOrSid, callSourceSid: callSourceSid, streemApiUpdateCompanyCallSourceRequest: streemApiUpdateCompanyCallSourceRequest });
        return await response.value();
    }
    /**
     * Change the current Identity Provider for this Company.  WARNING: this will mean a clean slate of accounts, so previous logins will no longer work
     * Change Identity Provider
     */
    async updateCompanyIdentityProviderRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateCompanyIdentityProvider.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/identity-provider`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateCompanyIdentityProviderRequestToJSON(requestParameters.streemApiUpdateCompanyIdentityProviderRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUpdateCompanyIdentityProviderResponseFromJSON(jsonValue));
    }
    /**
     * Change the current Identity Provider for this Company.  WARNING: this will mean a clean slate of accounts, so previous logins will no longer work
     * Change Identity Provider
     */
    async updateCompanyIdentityProvider(companyCodeOrSid, streemApiUpdateCompanyIdentityProviderRequest) {
        const response = await this.updateCompanyIdentityProviderRaw({ companyCodeOrSid: companyCodeOrSid, streemApiUpdateCompanyIdentityProviderRequest: streemApiUpdateCompanyIdentityProviderRequest });
        return await response.value();
    }
    /**
     * Update hours of operation for a specific group in a company
     * Update hours of operation for group
     */
    async updateGroupHoursOfOperationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateGroupHoursOfOperation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling updateGroupHoursOfOperation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/hours`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateGroupHoursOfOperationRequestToJSON(requestParameters.streemApiUpdateGroupHoursOfOperationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupHoursOfOperationResponseFromJSON(jsonValue));
    }
    /**
     * Update hours of operation for a specific group in a company
     * Update hours of operation for group
     */
    async updateGroupHoursOfOperation(companyCodeOrSid, groupName, streemApiUpdateGroupHoursOfOperationRequest) {
        const response = await this.updateGroupHoursOfOperationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiUpdateGroupHoursOfOperationRequest: streemApiUpdateGroupHoursOfOperationRequest });
        return await response.value();
    }
    /**
     * Create image url for a group id
     * Create a group image url
     */
    async updateGroupImageUrlRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateGroupImageUrl.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling updateGroupImageUrl.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/image_url`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateGroupImageUrlRequestToJSON(requestParameters.streemApiUpdateGroupImageUrlRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUpdateGroupImageUrlResponseFromJSON(jsonValue));
    }
    /**
     * Create image url for a group id
     * Create a group image url
     */
    async updateGroupImageUrl(companyCodeOrSid, groupName, streemApiUpdateGroupImageUrlRequest) {
        const response = await this.updateGroupImageUrlRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiUpdateGroupImageUrlRequest: streemApiUpdateGroupImageUrlRequest });
        return await response.value();
    }
    /**
     * Update Note Template
     */
    async updateNoteTemplatesRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateNoteTemplates.');
        }
        if (requestParameters.noteTemplateSid === null || requestParameters.noteTemplateSid === undefined) {
            throw new runtime.RequiredError('noteTemplateSid', 'Required parameter requestParameters.noteTemplateSid was null or undefined when calling updateNoteTemplates.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/note-templates/{note_template_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"note_template_sid"}}`, encodeURIComponent(String(requestParameters.noteTemplateSid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateNoteTemplateRequestToJSON(requestParameters.streemApiUpdateNoteTemplateRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUpdateNoteTemplateResponseFromJSON(jsonValue));
    }
    /**
     * Update Note Template
     */
    async updateNoteTemplates(companyCodeOrSid, noteTemplateSid, streemApiUpdateNoteTemplateRequest) {
        const response = await this.updateNoteTemplatesRaw({ companyCodeOrSid: companyCodeOrSid, noteTemplateSid: noteTemplateSid, streemApiUpdateNoteTemplateRequest: streemApiUpdateNoteTemplateRequest });
        return await response.value();
    }
    /**
     */
    async uploadCompanyCallSourceLogoRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling uploadCompanyCallSourceLogo.');
        }
        if (requestParameters.callSourceSid === null || requestParameters.callSourceSid === undefined) {
            throw new runtime.RequiredError('callSourceSid', 'Required parameter requestParameters.callSourceSid was null or undefined when calling uploadCompanyCallSourceLogo.');
        }
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling uploadCompanyCallSourceLogo.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/call-source/{call_source_sid}/asset/{type}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"call_source_sid"}}`, encodeURIComponent(String(requestParameters.callSourceSid))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUploadCompanyCallSourceLogoRequestToJSON(requestParameters.streemApiUploadCompanyCallSourceLogoRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUploadCompanyCallSourceLogoResponseFromJSON(jsonValue));
    }
    /**
     */
    async uploadCompanyCallSourceLogo(companyCodeOrSid, callSourceSid, type, streemApiUploadCompanyCallSourceLogoRequest) {
        const response = await this.uploadCompanyCallSourceLogoRaw({ companyCodeOrSid: companyCodeOrSid, callSourceSid: callSourceSid, type: type, streemApiUploadCompanyCallSourceLogoRequest: streemApiUploadCompanyCallSourceLogoRequest });
        return await response.value();
    }
}
/**
    * @export
    * @enum {string}
    */
export var CreateCompanyAssetOperationType;
(function (CreateCompanyAssetOperationType) {
    CreateCompanyAssetOperationType["CALLSOURCELOGO"] = "COMPANY_UPLOAD_TYPE_CALL_SOURCE_LOGO";
    CreateCompanyAssetOperationType["INVALID"] = "COMPANY_UPLOAD_TYPE_INVALID";
    CreateCompanyAssetOperationType["LOGO"] = "COMPANY_UPLOAD_TYPE_LOGO";
    CreateCompanyAssetOperationType["ROOMOUTCOMECONFIG"] = "COMPANY_UPLOAD_TYPE_ROOM_OUTCOME_CONFIG";
    CreateCompanyAssetOperationType["WATERMARK"] = "COMPANY_UPLOAD_TYPE_WATERMARK";
})(CreateCompanyAssetOperationType || (CreateCompanyAssetOperationType = {}));
/**
    * @export
    * @enum {string}
    */
export var ListCompanyApiKeysExpires;
(function (ListCompanyApiKeysExpires) {
    ListCompanyApiKeysExpires["ANY"] = "EXPIRES_ANY";
    ListCompanyApiKeysExpires["NO"] = "EXPIRES_NO";
    ListCompanyApiKeysExpires["YES"] = "EXPIRES_YES";
})(ListCompanyApiKeysExpires || (ListCompanyApiKeysExpires = {}));
/**
    * @export
    * @enum {string}
    */
export var ListGroupAvailabilityStatus;
(function (ListGroupAvailabilityStatus) {
    ListGroupAvailabilityStatus["AVAILABLE"] = "AVAILABILITY_STATUS_AVAILABLE";
    ListGroupAvailabilityStatus["CONFIRMING"] = "AVAILABILITY_STATUS_CONFIRMING";
    ListGroupAvailabilityStatus["INVALID"] = "AVAILABILITY_STATUS_INVALID";
    ListGroupAvailabilityStatus["INCALL"] = "AVAILABILITY_STATUS_IN_CALL";
    ListGroupAvailabilityStatus["NOTAVAILABLE"] = "AVAILABILITY_STATUS_NOT_AVAILABLE";
    ListGroupAvailabilityStatus["OFFLINE"] = "AVAILABILITY_STATUS_OFFLINE";
    ListGroupAvailabilityStatus["RESERVED"] = "AVAILABILITY_STATUS_RESERVED";
})(ListGroupAvailabilityStatus || (ListGroupAvailabilityStatus = {}));
/**
    * @export
    * @enum {string}
    */
export var ListUsersForCompanyUserTypes;
(function (ListUsersForCompanyUserTypes) {
    ListUsersForCompanyUserTypes["INVITED"] = "USER_TYPE_INVITED";
    ListUsersForCompanyUserTypes["LOGIN"] = "USER_TYPE_LOGIN";
    ListUsersForCompanyUserTypes["SDK"] = "USER_TYPE_SDK";
    ListUsersForCompanyUserTypes["UNSPECIFIED"] = "USER_TYPE_UNSPECIFIED";
})(ListUsersForCompanyUserTypes || (ListUsersForCompanyUserTypes = {}));
/**
    * @export
    * @enum {string}
    */
export var UploadCompanyCallSourceLogoType;
(function (UploadCompanyCallSourceLogoType) {
    UploadCompanyCallSourceLogoType["CALLSOURCELOGO"] = "COMPANY_UPLOAD_TYPE_CALL_SOURCE_LOGO";
    UploadCompanyCallSourceLogoType["INVALID"] = "COMPANY_UPLOAD_TYPE_INVALID";
    UploadCompanyCallSourceLogoType["LOGO"] = "COMPANY_UPLOAD_TYPE_LOGO";
    UploadCompanyCallSourceLogoType["ROOMOUTCOMECONFIG"] = "COMPANY_UPLOAD_TYPE_ROOM_OUTCOME_CONFIG";
    UploadCompanyCallSourceLogoType["WATERMARK"] = "COMPANY_UPLOAD_TYPE_WATERMARK";
})(UploadCompanyCallSourceLogoType || (UploadCompanyCallSourceLogoType = {}));
//# sourceMappingURL=CompaniesApi.js.map